import { AbstractControl, FormControl, FormGroupDirective, FormsModule, NgControl, NgForm, Validators } from '@angular/forms';
import { ControlBaseComponent } from '../control-base/control-base.component';
import { profanity } from '../../../validators/swear-word.validator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { StateService } from '../../../services/state.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { Component, OnInit, Self } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

class InputErrorStateMatcher implements ErrorStateMatcher {
    constructor(private innerControl: NgControl) { }

    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        if (form!.submitted == false) {

            if (control?.pristine) {
                return this.errorsIgnoreRequired(this.innerControl.control!);
            }

            if (control!.touched) {
                return this.errorsIgnoreRequired(this.innerControl.control!);
            }

            return false;
        }

        return this.innerControl!.invalid == true;
    }

    errorsIgnoreRequired(control: AbstractControl | null): boolean {
        if (!control!.errors) {
            return false;
        } 
        else if (control!.errors['required'] == true) {
            return false;
        }

        return true;
    }
}

@Component({
    selector: 'minster-text-area',
    standalone: true,
    imports: [FormsModule, MatFormFieldModule, MatInputModule, MatIconModule, MatTooltipModule],
    templateUrl: './minster-text-area.component.html',
    styleUrl: './minster-text-area.component.css'
})

export class MinsterTextAreaComponent extends ControlBaseComponent<string> implements OnInit {
    _matcher = new InputErrorStateMatcher(this.controlDir);

    constructor(@Self() public controlDir: NgControl, stateService: StateService) {
        super(controlDir, stateService);
    }

    ngOnInit(): void {
        this.setup();

        const control = this.controlDir.control;
        let myValidators = [];

        if (this._required && !this._disabled) {
            myValidators.push(Validators.required);
        }

        myValidators.push(profanity);

        if (this._minLength) {
            myValidators.push(Validators.minLength(Number(this._minLength)));
        }

        if (this._maxLength) {
            myValidators.push(Validators.maxLength(Number(this._maxLength)));
        }

        if (control) {
            let validators = control.validator ? [control.validator, ...myValidators] : myValidators;

            control.setValidators(validators)
            control.updateValueAndValidity();
        }
    }

    valueUpdated(newValue: any) {
        this._value = newValue;
        this._propagateChange(this._value);

        if (this.controlDir?.errors?.['maxlength']) {
            this._labelData.validationErrorText = `The maximum number of characters is ${this._maxLength}`;
        }
        else if (this.controlDir?.errors?.['minlength']) {
            this._labelData.validationErrorText = `The minimum number of characters is ${this._minLength}`;
        }
        else if (this.controlDir?.errors?.['profanity']) {
            this._labelData.validationErrorText = 'Contains a naughty word!';
        }

        this._showValidationError = this.addClassInvalid && this.controlDir.control!.dirty;
    }

    get addClassRequired(): boolean {
        return this._required && !this._value
    }

    get addClassInvalid(): boolean {
        return this.controlDir.control?.errors != null && !this.addClassRequired;
    }
}
